export default __webpack_public_path__ + "static/media/img-3.55ef2ee4.jpg";